import api from "@/services/api.service";
import { required } from "vuelidate/lib/validators";

export default {
  name: "add",
  components: {},
  props: {},
  data() {
    return {
      caption: "Add Export Contact",
      vendors: [],
      formField: { tags: [], title: "", contact_values: {},type:""},
      submitStatus: null,
      filterCriteria: [{ columns: null, text_value: null }],
      //filterCriteriaColumns :[],
      map_headers: [],
      concateColumn: [{ name: null, columns: [null] }],
      selectedHeadersShow: [],
      existing_tags: [],
      permission_add: false,
      superAdmin:false
    };
  },
  computed: {},
  mounted() {},
  validations: {
    formField: {
      title: {
        required
      },
      type: {
        required
      },
      tags: {
        required
      }
    }
  },
  async created() {
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("add_export_contact") == true){
              this.getColumns();
              this.getTags();
              this.permission_add = permissions.includes("add_export_contact");
            }else if(response.data[0].role == 'super_admin'){
              this.getColumns();
              this.getTags();
              this.superAdmin = true;
            }else if(permissions.includes("list_export_contact") == true || permissions.includes("add_export_contact") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Export Contact List'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }   
  },
  methods: {
    makeToast(message = "", title = "Alert", variant = "warning") {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: 3000
      });
    },
    async getTags() {
      let response = await api.post("tags/list");
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
      if (response.status == "success") {
        response.data.forEach(
          function(e) {
            this.existing_tags.push({ key: e.tags.substring(0, 100), value: e.tags.substring(0, 100) });
          }.bind(this)
          );
      }
    },
    async getColumns() {
      var response = await  api.post('admin/mapping_headers/list')
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
      if (response.status == 'success') {
        if (response.data != '') {          
          response.data.data.forEach(function(e){                      
            this.map_headers.push({value:e.column_key,text:e.column});
          }.bind(this));                    
        } else {
          this.map_headers = [];
          this.makeToast(`No database headers found.`, 'Alert', 'danger')
        }      
      } else
      this.makeToast(`No database headers found.`, 'Alert', 'danger')
    },
    addFilterCriteria() {
      this.filterCriteria.push({ columns: null, text_value: null });
    },
    deleteFilterCriteria(index) {
      this.filterCriteria.splice(index, 1);
    },
    addConcateColumn() {
      this.concateColumn.push({ columns: [null], name: null });
    },
    deleteConcateColumn(index) {
      this.concateColumn.splice(index, 1);
    },
    addColumns(index) {
      this.concateColumn[index].columns.push(null);
    },
    deleteColumn(index, idx) {
      this.concateColumn[index].columns.splice(idx, 1);
    },
    selectedHeaders(index) {
      if (this.selectedHeadersShow.includes(this.map_headers[index])) {
        this.selectedHeadersShow.splice(
          this.selectedHeadersShow.indexOf(this.map_headers[index]),
          1
          );
      } else {
        this.selectedHeadersShow.push(this.map_headers[index]);
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.formField.marketing_event_id = this.$route.params.id;

        if (this.filterCriteria[0].columns === null || this.filterCriteria[0].text_value === null) {
          this.makeToast("Please, Add search criteria","Validation","danger",6000);
          return;
        }
        if (this.selectedHeadersShow.length === 0) {
          this.makeToast("Please, Select any columns","Validation","danger",6000);
          return;
        }

        this.formField.filter_criteria = {
          filter_criteria : this.filterCriteria,
          concate_column  : (this.concateColumn[0].name !== null ? this.concateColumn : []),
          selected_column : this.selectedHeadersShow.length != 0 ? this.selectedHeadersShow : [],
          match_with : this.formField.type
        };

        let response = await api.post("admin/export-contact/add",this.formField);
        if (!response)
          this.makeToast("Something went to wrong please try again","Alert","danger",6000);

        if (response.status == "success") {
          this.makeToast(response.message, "Success", "success");
          this.$router.push({ name: "Export Contact List" });
        } else {
          for (var error in response.errors) {
            this.makeToast(response.errors[error], "Alert", "danger");
          }
        }
      }
    }
  }
};
